namespace TabAurous.ProductDevelopment {
    export namespace DesignRequestService {
        export const baseUrl = 'ProductDevelopment/DesignRequest';

        export declare function Create(request: Serenity.SaveRequest<DesignRequestRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<DesignRequestRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<DesignRequestRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<DesignRequestRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function SubmitQuotation(request: TransactionRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ProductDevelopment/DesignRequest/Create",
            Update = "ProductDevelopment/DesignRequest/Update",
            Delete = "ProductDevelopment/DesignRequest/Delete",
            Retrieve = "ProductDevelopment/DesignRequest/Retrieve",
            List = "ProductDevelopment/DesignRequest/List",
            SubmitQuotation = "ProductDevelopment/DesignRequest/SubmitQuotation"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'SubmitQuotation'
        ].forEach(x => {
            (<any>DesignRequestService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
